import type { ISessionRepository } from '../../domain/ports';
import { sessionApi } from '../api';
import type {
  ListSessionsData,
  SessionsListResult,
  RevoqueSessionData,
  RevokeAllSessionsData,
  ApiResponse,
} from '../../application/dto/dtos';

/**
 * Adapte sessionApi vers le port ISessionRepository.
 */
export class SessionRepository implements ISessionRepository {
  listSessions(data: ListSessionsData): Promise<ApiResponse<SessionsListResult>> {
    return sessionApi.listSessions(data);
  }

  revokeSession(data: RevoqueSessionData): Promise<ApiResponse<void>> {
    return sessionApi.revokeSession(data);
  }

  revokeAllSessions(data: RevokeAllSessionsData): Promise<ApiResponse<void>> {
    return sessionApi.revokeAllSessions(data);
  }
}
